import React, {Component, ReactElement, ReactNode} from 'react'
import {ApplyInfo, NatGetApplications, SearchCondition, SearchResult} from '../repository/NatGetApplications'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import NatCurrentDateTimeRepo from '../../currentDateTime/repository/NatCurrentDateTimeRepo'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {SortOrder} from '../../../../components/shared/SortOrder'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../../app/TypeHelpers'
import ListSearchFormArea from '../../../../styledComponents/adminPage/ListSearchFormArea'
import {
    ADMINISTORATOR_MODE,
    APPLY_CATEGORY,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_ADMINISTRATOR,
    VALID_OR_NOT_CHECK,
} from '../../../../CodeMaster'
import {ApplyCategoryData, NatGetApplicationCategory} from '../repository/NatGetApplicationCategory'
import {PageMainArea} from '../../../../components/shared/hoc/withAdminPageTemplate'
import styled from 'styled-components'
import PPCheckboxGroup from '../../../../components/shared/forms/PPCheckboxGroup'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import PPSelect, {OptionProps} from '../../../../components/shared/forms/PPSelect'
import {
    FullWidthLeftRowFlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    RightRowFlexContainer,
    RowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import {NatGetRidge, RidgeData} from '../../ridge/repository/NatGetRidge'
import NatRidgeRepo from '../../ridge/repository/NatRidgeRepo'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import {HeadingAreaMessageParams} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {SearchResultCountDisplayProps} from '../../../../styledComponents/adminPage/SearchResultCountDisplay'
import {COMMON_CONSTANTS} from '../../../../CommonConstants'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {Messages} from '../../../../Messages'
import {AdminDefaultMediumButton} from '../../../../styledComponents/adminPage/Buttons'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../../styledComponents/adminPage/SortablePaginationTableBody'
import {SortDirection} from '@mui/material/TableCell'
import {formatDateTimeForUpdateDate, formatDateTimeWithoutSeconds} from '../../../../formatters/formatDate'
import {Box, DialogContent, DialogTitle, Link, TableCell, TableRow} from '@mui/material'
import PPComboBox from '../../../../components/shared/forms/PPComboBox'
import {Colors, FontWeights} from '../../../../styledComponents/Constants'
import {StyledLink} from '../../../../styledComponents/adminPage/Links'
import {Close, Search, Sort} from '@mui/icons-material'
import {DialogCloseButton} from '../../../../components/reservations/components/CommonStyle'
import PPRadioGroup from '../../../../components/shared/forms/PPRadioGroup'
import {TxtBold} from '../../../../styledComponents/ContentsArea'
import PPOutlinedTextField from '../../../../components/shared/forms/PPOutlinedTextField'
import {StatusSelector} from './StatusSelector'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {AdminDialog} from '../../../../components/shared/pageBaseComponents/AdminDialog'
import ListPaginationActionsForSp from '../../../../styledComponents/adminPage/ListPaginationActionsForSp'
import {CondominiumGroupData, NatGetCondominiumGroup} from '../../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../../condominiumGroup/repository/NatCondominiumGroupRepo'
import NatCondominiumGroupSelectComponent from '../../common/NatCondominiumGroupSelectComponent'
import {convertToRoomNumberForResident} from '../../../common/util/Natutil'
import {ApplyDialogActions, SpApplyStatusCell} from '../common/admin/NatAdminApplicationCommon'
import {SelectChangeEvent} from '@mui/material/Select'
import {Location} from 'react-router-dom'

const KEY_SEARCH_CONDITION: string = 'applyStatusListSearchCondition'
const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    RidgeRepo: NatRidgeRepo
    applicationRepo: NatApplicationRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroup: Nullable<CondominiumGroupData>
    applyCategories: ApplyCategoryData[] | null
    applyList: ApplyInfo[]
    applySearchResult: SearchResult
    ridge: RidgeData[] | null
    searchCondition: SearchCondition
    searchConditionSortInfo: SortOrder[]
    defaultApplyStatus: CheckBoxData[]
    noResultMessage: string
    isLoadCompleted: boolean
    openSpApplicationSearchDialog: boolean
    openSpApplicationSortOrderDialog: boolean
    spApplicationSortOrder: 'asc' | 'desc'
}

export interface CheckBoxData {
    id: string
    label: string
    disp: boolean
}

class NatAdminApplicationPage extends Component<Props & AdminPagePropsSet, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    selectedCondominiumCd: Nullable<string>
    selectedMode: Nullable<string>
    roleId: Nullable<string>
    subSortKey: SortOrder = new SortOrder('applyId', 'asc')

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.selectedCondominiumCd = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD)
        this.selectedMode = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.SELECTED_MODE)

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        // 検索条件の初期設定
        let defaultSearchCondition: SearchCondition = {}
        let lastSearchCondition: SearchCondition = {}

        // 前回検索条件が保持されていればデフォルト値として設定する
        const sessionStorageSearchCondition: string | null =
            SessionStorageHelper.getStringItemOrNull(KEY_SEARCH_CONDITION)

        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        } else {
            // 管理組合役員の場合、申請ステータスは「理事長承認待ち」状態とする
            const defaultStatus: string[] = []
            if (this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
                defaultStatus.push(RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value)
                // 前回検索条件が設定されていない場合、申請ステータスは「受付待ち」「ペット委員長承認待ち」「理事長承認待ち」状態とする
            } else {
                defaultStatus.push(RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value)
                defaultStatus.push(RESIDENT_APPLY_STATUS.PET_CHAIRMAN_WAITING.value)
                defaultStatus.push(RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value)
            }
            defaultSearchCondition.applyStatus = defaultStatus.join(',')
        }

        if (lastSearchCondition.pageNum) {
            lastSearchCondition.pageNum = Number(lastSearchCondition.pageNum)
            lastSearchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        } else {
            defaultSearchCondition.pageNum = COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[2]
            defaultSearchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        }

        const loginUserCondominiumGroupId = NatAdminLoginInfoSessionStorageHelper.getNumberItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID)
        const loginUserCondominiumGroupName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_NAME)
        if (this.selectedMode === ADMINISTORATOR_MODE.ALL.value &&
            !defaultSearchCondition.condominiumGroupId &&
            loginUserCondominiumGroupId &&
            loginUserCondominiumGroupName) {
            defaultSearchCondition.condominiumGroupId = loginUserCondominiumGroupId
            defaultSearchCondition.condominiumGroupName = loginUserCondominiumGroupName
        }

        if (this.selectedMode === ADMINISTORATOR_MODE.ALL.value &&
            !defaultSearchCondition.businessCenterSupport) {
            defaultSearchCondition.businessCenterSupport = VALID_OR_NOT_CHECK.NOT.value
        }

        if (Object.keys(lastSearchCondition).length) {
            defaultSearchCondition = {...lastSearchCondition}
        }

        this.state = {
            condominiumGroup: null,
            ridge: null,
            applyCategories: null,
            applyList: [],
            searchCondition: defaultSearchCondition,
            searchConditionSortInfo: [
                new SortOrder('applyStatus', 'asc'),
                new SortOrder('applyDatetime', 'desc'),
            ],
            defaultApplyStatus: [],
            applySearchResult: {},
            noResultMessage: '',
            isLoadCompleted: false,
            openSpApplicationSearchDialog: false,
            openSpApplicationSortOrderDialog: false,
            spApplicationSortOrder: 'desc',
        }

        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
        this.onChangeBusinessCenterSupport = this.onChangeBusinessCenterSupport.bind(this)
        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangeApplyCategoryCode = this.onChangeApplyCategoryCode.bind(this)
        this.onChangeRidgeCd = this.onChangeRidgeCd.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.changeApplyId = this.changeApplyId.bind(this)
        this.changeRoomNumber = this.changeRoomNumber.bind(this)
        this.handleSortApplication = this.handleSortApplication.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangeApplyStatusSp = this.handleChangeApplyStatusSp.bind(this)
        this.handleChangeRidgeCdSp = this.handleChangeRidgeCdSp.bind(this)
        this.handleChangeSortApplicationSp = this.handleChangeSortApplicationSp.bind(this)
        this.handleClickChangeSortButtonSp = this.handleClickChangeSortButtonSp.bind(this)
        this.handleClickSearchButtonSp = this.handleClickSearchButtonSp.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.showInitialMessage()
        try {
            const [applyCategoryResponse, condominiumGroupResponse, ridgeResponse] = await Promise.all([
                this.getApplicationCategories(),
                this.getCondominiumGroup(),
                this.getRidge(),
            ])

            this.setState({
                applyCategories: applyCategoryResponse,
                condominiumGroup: condominiumGroupResponse,
                ridge: ridgeResponse,
            })

            const condition = {
                ...this.state.searchCondition,
                page: COMMON_CONSTANTS.FIRST_PAGE,
                pageNum: this.context.showSpModePage ?
                    COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS_SP :
                    this.state.searchCondition.pageNum
            };
            // 申請一覧取得取得
            await this.getApplicationList(
                condition,
                this.state.searchConditionSortInfo,
            )

            this.setState({
                searchCondition: condition
            });

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getCondominiumGroup(): Promise<Nullable<CondominiumGroupData>> {
        if (this.selectedMode === ADMINISTORATOR_MODE.CONDOMINIUM.value) {
            return null
        }

        const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
            this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return condominiumGroupResponse?.details ?? null
    }

    async getRidge(): Promise<Nullable<RidgeData[]>> {
        if (this.selectedMode === ADMINISTORATOR_MODE.ALL.value) {
            return null
        }

        const ridgeResponse: Nullable<NatGetRidge> = await this.props.asyncCallFunction(
            this.props.RidgeRepo.getRidgeList.bind(this.props.RidgeRepo, this.selectedCondominiumCd ?
                this.selectedCondominiumCd : undefined),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return ridgeResponse?.details ?? null
    }

    async getApplicationCategories(): Promise<Nullable<ApplyCategoryData[]>> {
        const applyCategoryResponse: Nullable<NatGetApplicationCategory> = await this.props.asyncCallFunction(
            this.props.applicationRepo.getApplicationCategory.bind(
                this.props.applicationRepo, this.selectedCondominiumCd ?
                    this.selectedCondominiumCd : undefined),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return applyCategoryResponse?.details ?? null
    }


    async getApplicationList(
        searchCondition: SearchCondition,
        searchConditionSortInfo: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            let applicationResponse: Nullable<NatGetApplications>
            if (this.selectedMode === ADMINISTORATOR_MODE.ALL.value) {
                applicationResponse = await this.props.asyncCallFunction(
                    this.props.applicationRepo.getApplicationForAllMode.bind(
                        this.props.applicationRepo,
                        searchCondition, [...searchConditionSortInfo, this.subSortKey]),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
            } else {
                applicationResponse = await this.props.asyncCallFunction(
                    this.props.applicationRepo.getApplication.bind(
                        this.props.applicationRepo,
                        this.selectedCondominiumCd ? this.selectedCondominiumCd : undefined,
                        searchCondition,
                        [...searchConditionSortInfo, this.subSortKey],
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
            }

            if (applicationResponse?.details) {
                let noResultMessage: string = ''
                if (applicationResponse.details.searchResult.total === 0) {
                    if (!this.isNoSearchConditionCheck()) {
                        noResultMessage = Messages.IOPCC0015.toString('申請')
                    } else {
                        noResultMessage = Messages.IOPCC0014.toString()
                    }
                }
                this.setState({
                    noResultMessage: noResultMessage,
                    applyList: applicationResponse.details.applyInfo,
                    applySearchResult: applicationResponse.details.searchResult,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    isNoSearchConditionCheck(): boolean {
        if (this.selectedMode === ADMINISTORATOR_MODE.ALL.value) {
            if (this.state.searchCondition.businessCenterSupport === VALID_OR_NOT_CHECK.NOT.value &&
                this.state.searchCondition.condominiumCd === undefined &&
                this.state.searchCondition.condominiumName === undefined &&
                this.state.searchCondition.applyStatus === '' &&
                this.state.searchCondition.applyCategory === undefined &&
                this.state.searchCondition.applyId === undefined) {
                return false
            }
        } else {
            if (this.state.searchCondition.applyStatus === '' &&
                this.state.searchCondition.applyCategory === undefined &&
                this.state.searchCondition.applyId === undefined &&
                this.state.searchCondition.ridgeCd === undefined &&
                this.state.searchCondition.roomNumber === undefined) {
                return false
            }
        }
        return true
    }

    getRidgeList(): OptionProps[] {
        let ridges: OptionProps[] = []
        if (this.state.ridge) {
            ridges = this.state.ridge.map((ridge) => {
                return ({
                    label: `${ridge.ridgeCd} : ${ridge.ridgeName}`,
                    value: `${ridge.ridgeCd}`,
                })
            })
        }

        return [{
            label: '指定なし',
            value: '',
        }, ...ridges]
    }

    judgeCheckStatus(applyStatus: string): boolean {
        if (!this.state.searchCondition || !this.state.searchCondition.applyStatus) {
            return false
        }
        const roleArray: string[] = this.state.searchCondition.applyStatus.split(',')
        return roleArray.indexOf(applyStatus) >= 0
    }

    clickApplyStatus(label: string, checked: boolean): void {

        const checkedStatus = RESIDENT_APPLY_STATUS.values().filter(role => {
            return role.label === label
        })

        if (this.state.searchCondition.applyStatus) {
            const checkedStatusArray: string[] = this.state.searchCondition.applyStatus.split(',')
            if (checked) {
                checkedStatusArray.push(checkedStatus[0].value)
            } else {
                checkedStatusArray.splice(checkedStatusArray.indexOf(checkedStatus[0].value), 1)
            }
            const searchCondition = this.state.searchCondition
            searchCondition.applyStatus = checkedStatusArray.join(',')
            this.setState({searchCondition: searchCondition})
        } else {
            if (checked) {
                const searchCondition = this.state.searchCondition
                searchCondition.applyStatus = checkedStatus[0].value
                this.setState({searchCondition: searchCondition})
            }
        }
    }

    handleChangeApplyStatusSp(selectedApplyStatus: RESIDENT_APPLY_STATUS[]): void {
        const searchCondition = this.state.searchCondition
        searchCondition.applyStatus = selectedApplyStatus.map(status => status.value).join(',')
        this.setState({searchCondition: searchCondition})
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.applyList.length === 0) {
            return {noResultMessage: this.state.noResultMessage}
        }

        return {
            totalCount: this.state.applySearchResult.total ? this.state.applySearchResult.total : undefined,
            rowsPerPage: this.state.searchCondition.pageNum,
            page: this.state.searchCondition.page,
        }
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    getDispApplyStatus(applyStatusCode: string): string {
        const applyStatus = RESIDENT_APPLY_STATUS.codeToEnumConstants(applyStatusCode)
        if (applyStatus) {
            return applyStatus.label
        } else {
            return ''
        }
    }

    getDispApplyCategory(applyCategory: string): string {
        const applyStatus = APPLY_CATEGORY.codeToEnumConstants(applyCategory)
        if (applyCategory) {
            return applyStatus.label
        } else {
            return ''
        }
    }

    changeApplyId(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.applyId = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    changeRoomNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.roomNumber = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.page = newPage
        await this.getApplicationList(
            this.state.searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: SearchCondition = {
            applyStatus: this.state.searchCondition.applyStatus,
            applyCategory: this.state.searchCondition.applyCategory,
            applyId: this.state.searchCondition.applyId,
            ridgeCd: this.state.searchCondition.ridgeCd,
            roomNumber: this.state.searchCondition.roomNumber,
            pageNum: Number(event.target.value),

        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.pageNum = Number(event.target.value)
        searchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getApplicationList(
            this.state.searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    async handleSortApplication(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.getApplicationList(
            this.state.searchCondition,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    handleChangeSortApplicationSp(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            spApplicationSortOrder: event.target.value === 'asc' ? 'asc' : 'desc',
        })
    }

    async handleClickChangeSortButtonSp(): Promise<void> {
        let sortOrders: SortOrder[]
        sortOrders = [new SortOrder('applyDatetime', this.state.spApplicationSortOrder)]
        await this.getApplicationList(
            this.state.searchCondition,
            sortOrders,
        )
        this.setState({
            searchConditionSortInfo: sortOrders,
            openSpApplicationSortOrderDialog: false,
        })
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        // 検索条件を保持
        const lastSearchCondition: SearchCondition = {
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            condominiumGroupName: this.state.searchCondition.condominiumGroupName,
            businessCenterSupport: this.state.searchCondition.businessCenterSupport,
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            applyStatus: this.state.searchCondition.applyStatus,
            applyCategory: this.state.searchCondition.applyCategory,
            applyId: this.state.searchCondition.applyId,
            ridgeCd: this.state.searchCondition.ridgeCd,
            roomNumber: this.state.searchCondition.roomNumber,
            pageNum: this.state.searchCondition.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchCondition = this.state.searchCondition
        searchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getApplicationList(
            searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    handleClickSearchButtonSp(): void {
        this.onClickSearchButton()
        this.setState({
            openSpApplicationSearchDialog: false,
        })
    }

    onChangeCondominiumGroupId(condominiumGroupId: number, condominiumGroupName?: string): void {
        const searchConditions = this.state.searchCondition
        searchConditions.condominiumGroupId = condominiumGroupId
        searchConditions.condominiumGroupName = condominiumGroupName?.trim()
        this.setState({searchCondition: searchConditions})
    }

    onChangeBusinessCenterSupport(label: string, checked: boolean): void {
        const searchConditions = this.state.searchCondition
        searchConditions.businessCenterSupport = checked ?
            VALID_OR_NOT_CHECK.VALID.value : VALID_OR_NOT_CHECK.NOT.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.condominiumCd = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.condominiumName = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeApplyCategoryCode(selectedValue: string): void {
        const searchConditions = this.state.searchCondition
        searchConditions.applyCategory = selectedValue
        this.setState({searchCondition: searchConditions})
    }

    onChangeRidgeCd(event: SelectChangeEvent<unknown>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.ridgeCd = event.target.value as string
        this.setState({searchCondition: searchCondition})
    }

    handleChangeRidgeCdSp(selectedValue: string): void {
        const searchCondition = this.state.searchCondition
        searchCondition.ridgeCd = selectedValue
        this.setState({searchCondition: searchCondition})
    }

    handleClickSpApplicationCard = (selectedApply: ApplyInfo, condominiumCd: Nullable<string>) => (): void => {
        if (!condominiumCd) {
            return
        }

        if (this.checkNoAuthorityToView(selectedApply.applyStatus)) {
            return
        }

        const applyUrl = this.getApplyUrl(selectedApply, condominiumCd)
        this.props.navigate(applyUrl)
    }

    checkNoAuthorityToView(applyStatus: string): boolean {
        if (this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value &&
            (applyStatus === RESIDENT_APPLY_STATUS.COMPLETE.value ||
                applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value)) {
            return true
        }
        return false
    }

    renderApplyStatusCheckBox(): ReactNode {
        const labels: { label: string, checked: boolean }[] = []
        const applyStatusMaster = RESIDENT_APPLY_STATUS.values()

        if (this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            applyStatusMaster
                .filter(applyStatusCd => +applyStatusCd.value > 1)
                .map((applyStatus) => (
                    labels.push(
                        {
                            label: applyStatus.label,
                            checked: this.judgeCheckStatus(applyStatus.value),
                        },
                    )
                ))
        } else {
            applyStatusMaster
                .map((applyStatus) => (
                    labels.push(
                        {
                            label: applyStatus.label,
                            checked: this.judgeCheckStatus(applyStatus.value),
                        },
                    )
                ))
        }
        return (
            <StyledPPCheckboxGroup
                row
                data={labels}
                onChangeChecked={this.clickApplyStatus.bind(this)}
            />
        )
    }

    renderApplicationSearchInfoForAllMode(): ReactNode {
        return (
            <>
                <Box pl={'8px'} pt={'8px'}>
                    <LeftRowFlexContainer>
                        <SearchCategoryColumnContainer>物件情報</SearchCategoryColumnContainer>
                        <Box width={'126px'}>物件グループを選択</Box>
                        <SearchInputContainer>
                            <LeftColumnFlexContainer>
                                <Box width={'570px'} ml={'8px'}>
                                    {this.state.condominiumGroup &&
                                        <NatCondominiumGroupSelectComponent
                                            condominiumGroup={this.state.condominiumGroup}
                                            onChangeSelectedCondominiumGroupId={this.onChangeCondominiumGroupId}
                                            defaultValue={(this.state.searchCondition.condominiumGroupId) ?
                                                this.state.searchCondition.condominiumGroupId : null}
                                            requiredFlag={true}
                                            eventKeys={['condominiumGroupId']}
                                            eventEmitter={this.props.eventEmitter}
                                            autoFocus={true}
                                        />
                                    }
                                </Box>
                            </LeftColumnFlexContainer>
                        </SearchInputContainer>
                    </LeftRowFlexContainer>
                    <LeftRowFlexContainer>
                        <SearchCategoryColumnContainer/>
                        <Box width={'126px'}/>
                        <SearchInputContainer>
                            <Box ml={'12px'}>
                                <StyledPPCheckboxGroup
                                    row
                                    data={[{
                                        label: '事務センター対応物件のみ',
                                        checked: this.state.searchCondition.businessCenterSupport
                                            === VALID_OR_NOT_CHECK.VALID.value,
                                    }]}
                                    onChangeChecked={this.onChangeBusinessCenterSupport}
                                />
                            </Box>
                        </SearchInputContainer>
                    </LeftRowFlexContainer>
                    <SearchRowContainer>
                        <SearchCategoryColumnContainer/>
                        <SearchColumnContainerForAll>物件コード</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            <Box width={'300px'}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 6,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumCd}
                                    defaultValue={this.state.searchCondition.condominiumCd}
                                />
                            </Box>
                        </SearchInputContainer>
                    </SearchRowContainer>
                    <SearchRowContainer>
                        <SearchCategoryColumnContainer/>
                        <SearchColumnContainerForAll>物件名</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            <Box width={'300px'}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.onChangeCondominiumName}
                                    defaultValue={this.state.searchCondition.condominiumName}
                                />
                            </Box>
                        </SearchInputContainer>
                    </SearchRowContainer>
                    <SearchRowContainer>
                        <SearchCategoryColumnContainer>申請情報</SearchCategoryColumnContainer>
                        <SearchColumnContainerForAll>ステータス</SearchColumnContainerForAll>
                        <SearchInputContainer>
                            {this.renderApplyStatusCheckBox()}
                        </SearchInputContainer>
                    </SearchRowContainer>
                    <LeftRowFlexContainer>
                        <SearchCategoryColumnContainer/>
                        <SearchColumnContainerForAll>申請区分</SearchColumnContainerForAll>
                        {this.state.applyCategories &&
                            <ComboBoxWrapperPc>
                                <PPComboBox
                                    options={this.state.applyCategories.map(category => (
                                        {label: category.applyName, value: category.applyCategory}
                                    ))}
                                    onChangeSelected={this.onChangeApplyCategoryCode}
                                    defaultValue={this.state.searchCondition.applyCategory ?
                                        this.state.searchCondition.applyCategory : null}
                                    eventKeys={['applyCategory']}
                                    eventEmitter={this.props.eventEmitter}
                                ></PPComboBox>
                            </ComboBoxWrapperPc>
                        }
                        <Box flexShrink={'2'} width={'62px'}/>
                        <Box flexShrink={0}>申請ID</Box>
                        <Box flexShrink={'2'} width={'63px'}/>
                        <Box flexBasis={'300px'}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 8,
                                    },
                                }}
                                fullWidth
                                onChange={this.changeApplyId}
                                defaultValue={this.state.searchCondition.applyId}
                                eventKeys={['applyId']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </Box>
                        <Box flex={1} ml={'16px'}>
                            <RightRowFlexContainer>
                                <SearchButton onClick={this.onClickSearchButton}>
                                    検索する
                                </SearchButton>
                            </RightRowFlexContainer>
                        </Box>
                    </LeftRowFlexContainer>
                </Box>
            </>
        )
    }

    renderApplicationInfo(): ReactNode {
        return (
            <Box pl={'8px'}>
                <SearchRowContainer>
                    <SearchColumnContainer>ステータス</SearchColumnContainer>
                    <SearchInputContainer>
                        {this.renderApplyStatusCheckBox()}
                    </SearchInputContainer>
                </SearchRowContainer>
                <SearchRowContainer>
                    <SearchColumnContainer>申請区分</SearchColumnContainer>
                    <ComboBoxWrapperPc>
                        {
                            this.state.applyCategories &&
                            <>
                                <PPComboBox
                                    options={this.state.applyCategories.map(category => (
                                        {label: category.applyName, value: category.applyCategory}
                                    ))}
                                    onChangeSelected={this.onChangeApplyCategoryCode}
                                    defaultValue={this.state.searchCondition.applyCategory ?
                                        this.state.searchCondition.applyCategory : null}
                                    eventKeys={['applyCategory']}
                                    eventEmitter={this.props.eventEmitter}
                                ></PPComboBox>
                            </>
                        }
                    </ComboBoxWrapperPc>
                    <Box flexShrink={'2'} width={'62px'}/>
                    <Box flexShrink={0}>申請ID</Box>
                    <Box flexShrink={'2'} width={'63px'}/>
                    <Box flexBasis={'300px'}>
                        <PPTextField
                            InputProps={{
                                inputProps: {
                                    maxLength: 8,
                                },
                            }}
                            fullWidth
                            onChange={this.changeApplyId}
                            defaultValue={this.state.searchCondition.applyId}
                            eventKeys={['applyId']}
                            eventEmitter={this.props.eventEmitter}
                        />
                    </Box>
                </SearchRowContainer>
                <LeftRowFlexContainer>
                    <SearchColumnContainer>申請者</SearchColumnContainer>
                    <span style={{paddingLeft: '16px', width: '80px', flexShrink: 0}}>棟名</span>
                    <PPSelect
                        data={this.getRidgeList()}
                        onChange={this.onChangeRidgeCd.bind(this)}
                        style={{width: '170px'}}
                        eventKeys={['ridgeCd']}
                        eventEmitter={this.props.eventEmitter}
                        value={this.state.searchCondition.ridgeCd}
                    />
                    <Box width={'48px'}/>
                    <span style={{width: '80px', flexShrink: 0}}>部屋番号</span>
                    <PPTextField
                        InputProps={{
                            inputProps: {
                                maxLength: 4,
                            },
                        }}
                        style={{width: '170px'}}
                        onChange={this.changeRoomNumber}
                        defaultValue={this.state.searchCondition.roomNumber}
                        eventKeys={['roomNumber']}
                        eventEmitter={this.props.eventEmitter}
                    />
                    <Box width={'430px'}/>
                    <SearchButton onClick={this.onClickSearchButton}>
                        検索する
                    </SearchButton>
                </LeftRowFlexContainer>
            </Box>
        )
    }

    renderApplicationTable(applyList: ApplyInfo[]): Nullable<ReactElement> {
        if (applyList.length === 0) {
            return null
        }
        let headers: SortableTableHeaderCell[]
        if (this.selectedMode === ADMINISTORATOR_MODE.ALL.value) {
            headers = [
                {
                    id: 'applyStatus',
                    label: 'ステータス',
                    sortable: true,
                    direction: this.getSortDirection('applyStatus'),
                },
                {id: 'applyId', label: '申請ID', align: 'left'},
                {id: 'applyCategory', label: '申請区分', align: 'left'},
                {id: 'condominiumName', label: '物件名', align: 'left'},
                {id: 'applyUserRoomNumber', label: '部屋番号', align: 'left'},
                {id: 'applyUserName', label: '申請者氏名', align: 'left'},
                {
                    id: 'applyDatetime',
                    label: '申請日時',
                    align: 'left',
                    sortable: true,
                    direction: this.getSortDirection('applyDatetime'),
                },
            ]
        } else {
            headers = [
                {
                    id: 'applyStatus',
                    label: 'ステータス',
                    sortable: true,
                    direction: this.getSortDirection('applyStatus'),
                },
                {id: 'applyId', label: '申請ID', align: 'left'},
                {id: 'applyCategory', label: '申請区分', align: 'left'},
                {id: 'applyUserRoomNumber', label: '部屋番号', align: 'left'},
                {id: 'applyUserName', label: '申請者氏名', align: 'left'},
                {
                    id: 'applyDatetime',
                    label: '申請日時',
                    align: 'left',
                    sortable: true,
                    direction: this.getSortDirection('applyDatetime'),
                },
            ]
        }
        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.applySearchResult.total ? this.state.applySearchResult.total : 0,
                    rowsPerPage:
                        this.state.searchCondition.pageNum ? this.state.searchCondition.pageNum : 0,
                    page: this.state.searchCondition.page ? this.state.searchCondition.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSortApplication}
                />
                <SortablePaginationTableBody>
                    {this.state.applyList.map(
                        apply => this.selectedMode === ADMINISTORATOR_MODE.ALL.value ?
                            this.renderApplicationRecordForAll(apply) :
                            this.renderApplicationRecord(apply, this.selectedCondominiumCd),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    renderApplicationRecordForAll(apply: ApplyInfo): ReactElement {
        const applyUrl: string = this.getApplyUrl(apply, apply.condominiumCd)

        return (
            <TableRow key={apply.applyId}>
                <TableCell style={{width: '196px'}} align={'center'}>
                    <ApplyStatusCell status={apply.applyStatus}>
                        {this.getDispApplyStatus(apply.applyStatus)}
                    </ApplyStatusCell>
                </TableCell>
                <TableCell style={{width: '115px'}}>
                    <Link href={applyUrl} underline="hover">{apply.applyId}</Link>
                </TableCell>
                <TableCell style={{width: '205px'}}>
                    {this.getDispApplyCategory(apply.applyCategory)}
                </TableCell>
                <TableCell style={{width: '280px'}}>
                    {apply.condominiumName}
                </TableCell>
                <TableCellWordBreakAll style={{width: '120px'}}>
                    {`${apply.applyUserRidgeName} ${convertToRoomNumberForResident(apply.applyUserRoomNumber)}`}
                </TableCellWordBreakAll>
                <TableCellWordBreakAll style={{width: '180px'}}>
                    {`${apply.applyUserFamilyName} ${apply.applyUserFirstName}`}
                </TableCellWordBreakAll>
                <TableCell>
                    {formatDateTimeForUpdateDate(apply.applyDatetime)}
                </TableCell>
            </TableRow>
        )
    }

    renderApplicationRecord(apply: ApplyInfo, condominiumCd: Nullable<string>): ReactElement {
        if (!condominiumCd) {
            return <></>
        }
        const applyUrl: string = this.getApplyUrl(apply, condominiumCd)

        return (
            <TableRow key={apply.applyId}>
                <TableCell style={{width: '196px'}} align={'center'}>
                    <ApplyStatusCell status={apply.applyStatus}>
                        {this.getDispApplyStatus(apply.applyStatus)}
                    </ApplyStatusCell>
                </TableCell>
                <TableCell style={{width: '115px'}}>
                    {
                        this.checkNoAuthorityToView(apply.applyStatus) ?
                            apply.applyId : <Link href={applyUrl} underline="hover">{apply.applyId}</Link>
                    }
                </TableCell>
                <TableCell style={{width: '300px'}}>
                    {this.getDispApplyCategory(apply.applyCategory)}
                </TableCell>
                <TableCellWordBreakAll style={{width: '200px'}}>
                    {`${apply.applyUserRidgeName} ${convertToRoomNumberForResident(apply.applyUserRoomNumber)}`}
                </TableCellWordBreakAll>
                <TableCellWordBreakAll style={{width: '280px'}}>
                    {`${apply.applyUserFamilyName} ${apply.applyUserFirstName}`}
                </TableCellWordBreakAll>
                <TableCell>
                    {formatDateTimeForUpdateDate(apply.applyDatetime)}
                </TableCell>
            </TableRow>
        )
    }

    getApplyUrl(apply: ApplyInfo, condominiumCd: string): string {

        switch (apply.applyCategory) {
            case APPLY_CATEGORY.CONTACT_ADDRESS_ON_EMERGENCY.value:
                return `/admin/condominiums/${condominiumCd}/applications/contactAddressOnEmergencies/${apply.applyId}`
            case APPLY_CATEGORY.PARKING_USE_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/parkingUses/${apply.applyId}`
            case APPLY_CATEGORY.PARKING_USE_CANCEL.value:
                return `/admin/condominiums/${condominiumCd}/applications/parkingUsesWithdrawal/${apply.applyId}`
            case APPLY_CATEGORY.CAR_CHANGE.value:
                return `/admin/condominiums/${condominiumCd}/applications/parkingUsesChange/${apply.applyId}`
            case APPLY_CATEGORY.BICYCLE_PARKING_USE_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/bicycleParkingUses/${apply.applyId}`
            case APPLY_CATEGORY.BICYCLE_PARKING_USE_ADMIT_CANCEL.value:
                return `/admin/condominiums/${condominiumCd}/applications/bicycleParkingUsesWithdrawal/${apply.applyId}`
            case APPLY_CATEGORY.BIKE_PARKING_USE_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/bikeParkingUses/${apply.applyId}`
            case APPLY_CATEGORY.BIKE_PARKING_USE_ADMIT_CANCEL.value:
                return `/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesWithdrawal/${apply.applyId}`
            case APPLY_CATEGORY.BIKE_CHANGE.value:
                return `/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesChange/${apply.applyId}`
            case APPLY_CATEGORY.BREEDING_PETS_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/breedingPets/${apply.applyId}`
            case APPLY_CATEGORY.MEDICAL_EXAMINATION_REPORT.value:
                return `/admin/condominiums/${condominiumCd}/applications/petMedicalCheckUpReport/${apply.applyId}`
            case APPLY_CATEGORY.BREEDING_PETS_CANCEL.value:
                return `/admin/condominiums/${condominiumCd}/applications/breedingPetsStop/${apply.applyId}`
            case APPLY_CATEGORY.CONSTRUCTION_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/constructions/${apply.applyId}`
            case APPLY_CATEGORY.CONSTRUCTION_COMPLETION.value:
                return `/admin/condominiums/${condominiumCd}/applications/constructionsComplete/${apply.applyId}`
            case APPLY_CATEGORY.WINDOW_FILM_ATTACH_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/windowFilmAttaches/${apply.applyId}`
            case APPLY_CATEGORY.LONG_ABSENCE.value:
                return `/admin/condominiums/${condominiumCd}/applications/longAbsence/${apply.applyId}`
            case APPLY_CATEGORY.HEAVY_GOODS_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/heavyLoadsCarries/${apply.applyId}`
            case APPLY_CATEGORY.INSPECTION_APPLY.value:
                return `/admin/condominiums/${condominiumCd}/applications/inspections/${apply.applyId}`
            case APPLY_CATEGORY.OWNERSHIP_TRANSFER.value:
                return `/admin/condominiums/${condominiumCd}/applications/ownershipTransfers/${apply.applyId}/completed`
            default:
                return ''
        }
    }

    renderApplicationSearchInfoForSpAllMode(): ReactElement {
        return <SpDisplaySearchConditionArea>
            <StyledLink
                onClick={() => {
                    this.setState({openSpApplicationSearchDialog: true})
                }}>
                <Search/>検索
            </StyledLink>
            <Box height={'2px'}/>
            {this.state.searchCondition.condominiumGroupName &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>物件グループ</SpDisplaySearchConditionLabel>
                    <Box ml={'8px'}/>
                    <SpDisplaySearchCondition>
                        {this.state.searchCondition.businessCenterSupport === VALID_OR_NOT_CHECK.VALID.value ?
                            `${this.state.searchCondition.condominiumGroupName}（事務センター対応物件のみ）` :
                            this.state.searchCondition.condominiumGroupName
                        }
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {this.state.searchCondition.condominiumCd &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>物件コード</SpDisplaySearchConditionLabel>
                    <Box ml={'22px'}/>
                    <SpDisplaySearchCondition>
                        {this.state.searchCondition.condominiumCd}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {this.state.searchCondition.condominiumName &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>物件名</SpDisplaySearchConditionLabel>
                    <Box ml={'50px'}/>
                    <SpDisplaySearchCondition>
                        {this.state.searchCondition.condominiumName}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {this.state.searchCondition.applyStatus &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>ステータス</SpDisplaySearchConditionLabel>
                    <Box ml={'22px'}/>
                    <SpDisplaySearchCondition>
                        {this.state.searchCondition.applyStatus.split(',')
                            .map(value => RESIDENT_APPLY_STATUS.codeToEnumConstants(value).label).join('、')}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {this.state.searchCondition.applyCategory &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>申請区分</SpDisplaySearchConditionLabel>
                    <Box ml={'36px'}/>
                    <SpDisplaySearchCondition>
                        {APPLY_CATEGORY.codeToEnumConstants(this.state.searchCondition.applyCategory).label}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {this.state.searchCondition.applyId &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>申請ID</SpDisplaySearchConditionLabel>
                    <Box ml={'50px'}/>
                    <SpDisplaySearchCondition>
                        {this.state.searchCondition.applyId}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
        </SpDisplaySearchConditionArea>
    }

    renderApplicationSearchInfoForSp(): ReactElement {
        const {ridgeCd, roomNumber} = this.state.searchCondition
        let applyUser: string = ''
        if (ridgeCd) {
            const ridgeInfo = this.state.ridge?.find(ridge => ridge.ridgeCd === ridgeCd)
            if (ridgeInfo) {
                applyUser = applyUser + ridgeInfo.ridgeName
            }
            if (roomNumber) {
                applyUser = applyUser + ' ' + roomNumber
            }
        } else {
            if (roomNumber) {
                applyUser = roomNumber
            }
        }
        return <SpDisplaySearchConditionArea>
            <StyledLink
                onClick={() => {
                    this.setState({openSpApplicationSearchDialog: true})
                }}>
                <Search/>検索
            </StyledLink>
            <Box height={'2px'}/>
            {this.state.searchCondition.applyStatus &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>ステータス</SpDisplaySearchConditionLabel>
                    <Box ml={'8px'}/>
                    <SpDisplaySearchCondition>
                        {this.state.searchCondition.applyStatus.split(',')
                            .map(value => RESIDENT_APPLY_STATUS.codeToEnumConstants(value).label).join('、')}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {this.state.searchCondition.applyCategory &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>申請区分</SpDisplaySearchConditionLabel>
                    <Box ml={'22px'}/>
                    <SpDisplaySearchCondition>
                        {APPLY_CATEGORY.codeToEnumConstants(this.state.searchCondition.applyCategory).label}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {this.state.searchCondition.applyId &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>申請ID</SpDisplaySearchConditionLabel>
                    <Box ml={'36px'}/>
                    <SpDisplaySearchCondition>
                        {this.state.searchCondition.applyId}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
            {applyUser !== '' &&
                <SpDisplaySearchConditionContainer>
                    <SpDisplaySearchConditionLabel>申請者</SpDisplaySearchConditionLabel>
                    <Box ml={'36px'}/>
                    <SpDisplaySearchCondition>
                        {applyUser}
                    </SpDisplaySearchCondition>
                </SpDisplaySearchConditionContainer>
            }
        </SpDisplaySearchConditionArea>
    }

    renderApplicationSearchResultForSp(): ReactElement {
        return <>
            <Box height={'8px'}/>
            {this.state.applyList.length === 0
                ? this.state.noResultMessage
                : <>
                    <RowFlexContainer>
                        <LeftRowFlexContainer>
                            <TxtBold>
                                {this.state.applySearchResult.total}
                            </TxtBold>
                            件
                        </LeftRowFlexContainer>
                        <StyledLink
                            onClick={() => {
                                this.setState({openSpApplicationSortOrderDialog: true})
                            }}>
                            <Sort/>並び順
                        </StyledLink>
                    </RowFlexContainer>
                    <SpApplicationCardList>
                        {this.state.applyList.map((apply, index) => {
                            return <SpApplicationCard
                                unavailableStatus={this.checkNoAuthorityToView(apply.applyStatus)}
                                key={index}
                                onClick={this.handleClickSpApplicationCard(apply, apply.condominiumCd)}
                            >
                                <SpApplicationCardHeader>
                                    {formatDateTimeWithoutSeconds(apply.applyDatetime)} に提出
                                    <SpApplyStatusCell status={apply.applyStatus}>
                                        {this.getDispApplyStatus(apply.applyStatus)}
                                    </SpApplyStatusCell>
                                </SpApplicationCardHeader>
                                <LeftColumnFlexContainer>
                                    <Box height={'8px'}/>
                                    {apply.applyId}
                                    <SpApplicationCardApplyStatus>
                                        {this.getDispApplyCategory(apply.applyCategory)}
                                    </SpApplicationCardApplyStatus>
                                    {this.selectedMode === ADMINISTORATOR_MODE.ALL.value ?
                                        <>
                                            <SpApplicationCardApplyUser>
                                                {apply.condominiumName}
                                            </SpApplicationCardApplyUser>
                                            <LeftRowFlexContainer>
                                                {`${apply.applyUserRidgeName} ${convertToRoomNumberForResident(apply.applyUserRoomNumber)}　${apply.applyUserFamilyName} ${apply.applyUserFirstName}`}
                                            </LeftRowFlexContainer>
                                        </> :
                                        <SpApplicationCardApplyUser>
                                            {`${apply.applyUserRidgeName} ${convertToRoomNumberForResident(apply.applyUserRoomNumber)}　${apply.applyUserFamilyName} ${apply.applyUserFirstName}`}
                                        </SpApplicationCardApplyUser>
                                    }
                                </LeftColumnFlexContainer>
                            </SpApplicationCard>
                        })}
                    </SpApplicationCardList>
                    <Box p={'8px 0'}>
                        <ListPaginationActionsForSp
                            count={this.state.applySearchResult.total ? this.state.applySearchResult.total : 0}
                            onPageChange={this.handleChangePage}
                            page={this.state.searchCondition.page ? this.state.searchCondition.page : 0}
                            rowsPerPage={this.state.searchCondition.pageNum ? this.state.searchCondition.pageNum : 0}
                        />
                    </Box>
                </>
            }
        </>
    }

    renderSearchFormForSpAllMode(
        applyStatusList: RESIDENT_APPLY_STATUS[],
        selectedApplyStatusList: RESIDENT_APPLY_STATUS[],
    ): Nullable<ReactElement> {
        return (
            <>
                <Box fontWeight={FontWeights.Bold}>物件情報</Box>
                <Box mt={'8px'}>物件グループを選択</Box>
                {
                    this.state.condominiumGroup &&
                    <ComboBoxWrapperSp>
                        <NatCondominiumGroupSelectComponent
                            condominiumGroup={this.state.condominiumGroup}
                            onChangeSelectedCondominiumGroupId=
                                {this.onChangeCondominiumGroupId}
                            defaultValue={(this.state.searchCondition.condominiumGroupId) ?
                                this.state.searchCondition.condominiumGroupId : null}
                            requiredFlag={true}
                            eventKeys={['condominiumGroupId']}
                            eventEmitter={this.props.eventEmitter}
                            autoFocus={true}
                        />
                    </ComboBoxWrapperSp>
                }
                <StyledPPCheckboxGroup
                    row
                    data={[{
                        label: '事務センター対応物件のみ',
                        checked: this.state.searchCondition.businessCenterSupport
                            === VALID_OR_NOT_CHECK.VALID.value,
                    }]}
                    onChangeChecked={this.onChangeBusinessCenterSupport}
                />
                <Box mt={'8px'}>物件コード</Box>
                <PPOutlinedTextField
                    InputProps={{
                        inputProps: {
                            maxLength: 6,
                        },
                    }}
                    variant={'outlined'}
                    style={{width: '100%'}}
                    onChange={this.onChangeCondominiumCd}
                    defaultValue={this.state.searchCondition.condominiumCd}
                    eventKeys={['applyId']}
                    eventEmitter={this.props.eventEmitter}
                />
                <Box mt={'16px'}>物件名</Box>
                <PPOutlinedTextField
                    InputProps={{
                        inputProps: {
                            maxLength: 50,
                        },
                    }}
                    variant={'outlined'}
                    style={{width: '100%'}}
                    onChange={this.onChangeCondominiumName}
                    defaultValue={this.state.searchCondition.condominiumName}
                    eventKeys={['applyId']}
                    eventEmitter={this.props.eventEmitter}
                />
                <Box mt={'24px'} fontWeight={FontWeights.Bold}>申請情報</Box>
                <Box mt={'8px'}>ステータス</Box>
                <StatusSelector
                    onChangeStatus={this.handleChangeApplyStatusSp}
                    statusList={applyStatusList}
                    selectedStatusList={selectedApplyStatusList}
                />
                <Box mt={'8px'}>申請区分</Box>
                {this.state.applyCategories &&
                    <ComboBoxWrapperSp>
                        <PPComboBox
                            options={this.state.applyCategories.map(category => (
                                {label: category.applyName, value: category.applyCategory}
                            ))}
                            onChangeSelected={this.onChangeApplyCategoryCode}
                            defaultValue={this.state.searchCondition.applyCategory ?? null}
                            eventKeys={['applyCategory']}
                            eventEmitter={this.props.eventEmitter}
                        />
                    </ComboBoxWrapperSp>
                }
                <Box mt={'16px'}>申請ID</Box>
                <PPOutlinedTextField
                    InputProps={{
                        inputProps: {
                            maxLength: 8,
                        },
                    }}
                    variant={'outlined'}
                    style={{width: '100%'}}
                    onChange={this.changeApplyId}
                    defaultValue={this.state.searchCondition.applyId}
                    eventKeys={['applyId']}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }

    renderSearchFormForSp(
        applyStatusList: RESIDENT_APPLY_STATUS[],
        selectedApplyStatusList: RESIDENT_APPLY_STATUS[],
    ): Nullable<ReactElement> {
        return (
            <>
                <SpSearchColumnContainer>ステータス</SpSearchColumnContainer>
                <StatusSelector
                    onChangeStatus={this.handleChangeApplyStatusSp}
                    statusList={applyStatusList}
                    selectedStatusList={selectedApplyStatusList}
                />
                <SpSearchColumnContainer>申請区分</SpSearchColumnContainer>
                {this.state.applyCategories &&
                    <ComboBoxWrapperSp>
                        <PPComboBox
                            options={this.state.applyCategories.map(category => (
                                {label: category.applyName, value: category.applyCategory}
                            ))}
                            onChangeSelected={this.onChangeApplyCategoryCode}
                            defaultValue={this.state.searchCondition.applyCategory ?? null}
                            eventKeys={['applyCategory']}
                            eventEmitter={this.props.eventEmitter}
                        />
                    </ComboBoxWrapperSp>
                }
                <SpSearchColumnContainer>申請ID</SpSearchColumnContainer>
                <PPOutlinedTextField
                    InputProps={{
                        inputProps: {
                            maxLength: 8,
                        },
                    }}
                    variant={'outlined'}
                    style={{width: '100%'}}
                    onChange={this.changeApplyId}
                    defaultValue={this.state.searchCondition.applyId}
                    eventKeys={['applyId']}
                    eventEmitter={this.props.eventEmitter}
                />
                <Box mt={'20px'}/>
                <SpSearchColumnContainer>申請者</SpSearchColumnContainer>
                <SpSearchSubColumnContainer>棟名</SpSearchSubColumnContainer>
                <ComboBoxWrapperSp>
                    <PPComboBox
                        options={this.getRidgeList()}
                        onChangeSelected={this.handleChangeRidgeCdSp}
                        defaultValue={this.state.searchCondition.ridgeCd ?? ''}
                        eventKeys={['applyCategory']}
                        eventEmitter={this.props.eventEmitter}
                    ></PPComboBox>
                </ComboBoxWrapperSp>
                <SpSearchSubColumnContainer>部屋番号</SpSearchSubColumnContainer>
                <PPOutlinedTextField
                    InputProps={{
                        inputProps: {
                            maxLength: 4,
                        },
                    }}
                    variant={'outlined'}
                    style={{width: '100%'}}
                    onChange={this.changeRoomNumber}
                    defaultValue={this.state.searchCondition.roomNumber}
                    eventKeys={['roomNumber']}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }

    renderPc(): Nullable<ReactElement> {
        return <>
            <ListSearchFormArea
                searchResult={this.searchResults()}
                onEnterKey={this.onClickSearchButton}>
                {this.selectedMode === ADMINISTORATOR_MODE.ALL.value ?
                    this.renderApplicationSearchInfoForAllMode() : this.renderApplicationInfo()}
            </ListSearchFormArea>
            <PageMainArea>
                {this.renderApplicationTable(this.state.applyList)}
            </PageMainArea>
        </>
    }

    renderSp(): Nullable<ReactElement> {
        const applyStatusList = this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value
            ? [RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING,
                RESIDENT_APPLY_STATUS.COMPLETE,
                RESIDENT_APPLY_STATUS.REJECTION]
            : RESIDENT_APPLY_STATUS.values()
        const selectedApplyStatusList = this.state.searchCondition.applyStatus
            ? this.state.searchCondition.applyStatus.split(',')
                .map(value => RESIDENT_APPLY_STATUS.codeToEnumConstants(value))
            : []

        return <>
            {this.selectedMode === ADMINISTORATOR_MODE.ALL.value ?
                this.renderApplicationSearchInfoForSpAllMode() : this.renderApplicationSearchInfoForSp()}
            {this.renderApplicationSearchResultForSp()}
            <AdminDialog
                open={this.state.openSpApplicationSearchDialog}
            >
                <SpDialogTitle>
                    <RowFlexContainer>
                        <SpDialogTitleFont>検索</SpDialogTitleFont>
                        <DialogCloseButton onClick={() => {
                            this.setState({openSpApplicationSearchDialog: false})
                        }}>
                            <Close fontSize={'large'}/>
                        </DialogCloseButton>
                    </RowFlexContainer>
                </SpDialogTitle>
                <SpDialogContent>
                    {this.selectedMode === ADMINISTORATOR_MODE.ALL.value ?
                        this.renderSearchFormForSpAllMode(applyStatusList, selectedApplyStatusList) :
                        this.renderSearchFormForSp(applyStatusList, selectedApplyStatusList)}
                </SpDialogContent>
                <ApplyDialogActions>
                    <SpDialogButton onClick={this.handleClickSearchButtonSp}>
                        検索する
                    </SpDialogButton>
                </ApplyDialogActions>
            </AdminDialog>
            <AdminDialog
                open={this.state.openSpApplicationSortOrderDialog}
            >
                <SpDialogTitle>
                    <RowFlexContainer>
                        <SpDialogTitleFont>並び順</SpDialogTitleFont>
                        <DialogCloseButton onClick={() => {
                            this.setState({openSpApplicationSortOrderDialog: false})
                        }}>
                            <Close fontSize={'large'}/>
                        </DialogCloseButton>
                    </RowFlexContainer>
                </SpDialogTitle>
                <SpDialogContent>
                    <div>申請日時</div>
                    <Box height={'12px'}/>
                    <PPRadioGroup
                        data={[
                            {
                                label: '提出日時が新しい順',
                                value: 'desc',
                            },
                            {
                                label: '提出日時が古い順',
                                value: 'asc',
                            },
                        ]}
                        value={this.state.spApplicationSortOrder}
                        onChange={this.handleChangeSortApplicationSp}
                    />
                </SpDialogContent>
                <ApplyDialogActions>
                    <SpDialogButton onClick={this.handleClickChangeSortButtonSp}>
                        並び替える
                    </SpDialogButton>
                </ApplyDialogActions>
            </AdminDialog>
        </>
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return spMode ? this.renderSp() : this.renderPc()
    }
}

NatAdminApplicationPage.contextType = AppAdminContext
export default createAdminPage(NatAdminApplicationPage)

const ApplyStatusCell = styled.button<{ status?: string }>`
  width: 156px;
  height: 29px;
  border: 0;
  border-radius: 40px;
  background: ${props => props.status === '8' ? 'linear-gradient(0deg, rgba(0, 175, 185, 0.4), rgba(0, 175, 185, 0.4)), #FFFFFF;' :
          props.status === '9' ? 'linear-gradient(0deg, #EDEDED, #EDEDED), #FFFFFF;' :
                  'linear-gradient(0deg, rgba(255, 191, 86, 0.4), rgba(255, 191, 86, 0.4)), #FFFFFF;'}
`

const SearchButton = styled(AdminDefaultMediumButton)`
  &.MuiButtonBase-root {
    width: 204px;
    height: 44px;
  }
`

const SpDialogButton = styled(AdminDefaultMediumButton)`
  &.MuiButtonBase-root {
    width: 100%;
    height: 50px;
  }
`

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`

const SearchRowContainer = styled(FullWidthLeftRowFlexContainer)`
  padding: 8px 0;
`

const SearchCategoryColumnContainer = styled.div`
  font-weight: bold;
  width: 56px;
  margin-right: 24px;
  flex-shrink: 0;
`

const StyledPPCheckboxGroup = styled(PPCheckboxGroup)`
  & .MuiTypography-root {
    font-size: 14px;
  }
`

const SearchColumnContainer = styled.div`
  width: 124px;
  flex-shrink: 0;
`

const SearchColumnContainerForAll = styled.div`
  width: 104px;
  flex-shrink: 0;
`

const SpSearchColumnContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 4px;
`

const SpSearchSubColumnContainer = styled.div`
  margin-top: 4px;
  margin-bottom: 4px;
`

const SearchInputContainer = styled.div`
  margin-left: 16px;
`

const SpDisplaySearchConditionArea = styled.div`
  margin-top: 16px;
  padding: 9px 16px 8px 16px;
  background-color: ${Colors.Surface};
  width: 100%;
`

const SpDisplaySearchConditionContainer = styled(LeftRowFlexContainer)`
  padding-top: 4px;
  align-items: flex-start;
`

const SpDisplaySearchConditionLabel = styled.div`
  color: ${Colors.AccentDark};
  word-break: keep-all;
`

const SpDisplaySearchCondition = styled.div`
  color: ${Colors.Body};
  overflow-wrap: anywhere;
`

const SpApplicationCardList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 8px;
`

const SpApplicationCard = styled.div<{ unavailableStatus?: boolean }>`
  padding: 0px 8px 8px 8px;
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 4px;
  background-color: ${Colors.Surface};
  box-shadow: 0 1px 8px 0 rgba(112, 112, 112, 0.4);
  overflow-wrap: anywhere;

  ${props => props.unavailableStatus ? `
  opacity: 0.5;
  pointer-events: none;
  ` : ``}
  &:hover {
    cursor: pointer;
  }
`

const SpApplicationCardHeader = styled(RowFlexContainer)`
  height: 28px;
  margin: 0px -8px;
  padding: 0px 8px;
  background-color: #f7f7f7;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-weight: ${FontWeights.Normal};
  color: ${Colors.AccentDark};
`

const SpApplicationCardApplyStatus = styled.span`
  font-weight: ${FontWeights.Bold};
  font-size: medium;
`

const SpApplicationCardApplyUser = styled(LeftRowFlexContainer)`
  margin-top: 8px;
`

const SpDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    padding: 16px 17px;
    border-bottom: 1px solid ${Colors.AccentLight};
  }
`

const SpDialogContent = styled(DialogContent)`
  padding: 16px;
`

const SpDialogTitleFont = styled.div`
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`

const ComboBoxWrapperPc = styled.div`
  width: 100%;
  max-width: 300px;
  min-width: 235px;
  margin-left: 16px;
  flex-grow: 1;
  flex-shrink: 2;
`

const ComboBoxWrapperSp = styled.div`
  .MuiInputBase-root {
    width: 100%;
  }
`
